<!-- Non-blocking status: a passive banner shown only while the socket is not
     connected (and the session has connected at least once — the initial
     handshake window on page load stays quiet). No backdrop, no modal,
     pointer-events disabled so it never blocks the page underneath (the
     retry button alone re-enables them for itself). -->
<div
    *ngIf="visible"
    class="connection-status"
    [class.connection-status--reconnecting]="status === 'reconnecting'"
    [class.connection-status--disconnected]="status === 'disconnected'"
    role="status"
    aria-live="polite">
    <span *ngIf="status === 'reconnecting'">Reconnecting to Viewbid…</span>
    <span *ngIf="status === 'disconnected'">Connection to Viewbid lost</span>
    <button
        type="button"
        class="connection-status__retry"
        (click)="refresh()"
        aria-label="Refresh page"
        title="Refresh page">
        <i class="fa-solid fa-rotate-right" aria-hidden="true"></i>
    </button>
</div>
